/**
 * We are using the videojs plugin: videojs-event-tracking see prefix `tracking:`
 * Also we are using standaard html5 event handlers see for a full list https://www.quackit.com/html_5/tags/html_5_event_handler_content_attributes.cfm
 */

import { track } from '@bnnvara/analytics/src/track';

const GAEventTracking = (player, duration, mediaId) => {
  // secondsToLoad: Total number of seconds between the player initializing a play request and when the first frame begins.
  player.on('tracking:firstplay', (e, data) => {
    track(
      'video-player-controls',
      'onFirstplay',
      `seconds-to-load`,
      data.secondsToLoad
    );
    track('video-player-controls', 'onFirstplay', `total-duration`, duration);
    track('video-player-controls', 'onFirstplay', `media-id`, Number(mediaId));
  });
  // pauseCount: Total number of Pause events triggered
  player.on('tracking:pause', (e, data) => {
    track('video-player-controls', 'onPause', `pause-count`, data.pauseCount);
  });
  // During playback, we are tracking how many times a person seeks, and the position a user has seeked to
  player.on('tracking:seek', (e, data) => {
    track('video-player-controls', 'click', `seek-count`, data.seekCount);
    track('video-player-controls', 'click', `seek-to`, data.seekTo);
  });
  // on25%
  player.on('tracking:first-quarter', (e, data) => {
    track('video-player', 'on25%', `seek-count`, data.seekCount);
    track('video-player', 'on25%', `pause-count`, data.pauseCount);
    track('video-player', 'on25%', `current-time`, data.currentTime);
  });
  // on50%
  player.on('tracking:second-quarter', (e, data) => {
    track('video-player', 'on50%', `seek-count`, data.seekCount);
    track('video-player', 'on50%', `pause-count`, data.pauseCount);
    track('video-player', 'on50%', `current-time`, data.currentTime);
  });
  // on75%
  player.on('tracking:third-quarter', (e, data) => {
    track('video-player', 'on75%', `seek-count`, data.seekCount);
    track('video-player', 'on75%', `pause-count`, data.pauseCount);
    track('video-player', 'on75%', `current-time`, data.currentTime);
  });
  // on100%
  player.on('tracking:fourth-quarter', (e, data) => {
    track('video-player', 'on100%', `seek-count`, data.seekCount);
    track('video-player', 'on100%', `pause-count`, data.pauseCount);
    track('video-player', 'on100%', `current-time`, data.currentTime);
  });
  // onEnded
  player.on('ended', () => track('video-player', 'onEnded', `ended`));
};

export default GAEventTracking;
